import { isNullOrUndefined } from "@qntm-code/utils";
import {FundingSourceStatus, FundingSourceType, PaymentType} from "@app/shared/enums/payment-type.enum";
import {PaymentTxnType} from "@app/shared/enums/txn-type.enum";

export class FundingSourceRequest {
  refId: number;
  fundingSourceType: FundingSourceType;
  fundingSourceStatus: FundingSourceStatus;
  canChangeFundingSource: boolean = false;
  label: string;
  paymentType: PaymentType;
  paymentTxnType: PaymentTxnType;
  defaultFundingSourceId: number;


  constructor(refId?: number, fundingSourceType?: FundingSourceType, fundingSourceStatus?: FundingSourceStatus, canChangeFundingSource?: boolean, label?: string) {
    this.refId = refId;
    this.fundingSourceType = fundingSourceType;
    if (!isNullOrUndefined(fundingSourceStatus)) {
      this.fundingSourceStatus = FundingSourceStatus.Verified;
    }
    if (!isNullOrUndefined(canChangeFundingSource)) {
      this.canChangeFundingSource = canChangeFundingSource;
    }
    if (!isNullOrUndefined(label)) {
      this.label = label;
    }
  }
}
